import { postData, getData, putData } from '../services/axiosServices'

export const getMyLabWithAttendanceCode = (code) => {
    let url = `learners/attendance/${code}`
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }
    return getData(url, { headers })
}
export const getMyLabWithoutAttendanceCode = (code) => {
    let url = `learners/myLab`
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`

    }
    return getData(url, { headers })
}
export const learnerCheckIn = (data, attendanceCode) => {
    let url = `learnerDailyAttendance/${attendanceCode}`
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`

    }
    return postData(url, data, { headers })
}
export const learnerPracticeNotes = (data) => {
    let url = 'learnerdailynotes'
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`

    }
    return postData(url, data, { headers })
}
export const learnerCheckOut = (data) => {
    let url = `learnerDailyAttendance`
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }
    return putData(url, data, { headers })
}

export const getAlllearnerAttendance = (learner_id) => {
    let url = `learnerDailyAttendance/${learner_id}` //'learnerDailyAttendance'
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }
    return getData(url, { headers })
}

export const getAlllearnerlabpractices = () => {
    let url = `learnerlabpractices`
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }
    return getData(url, { headers })
}

export const getTodaypractices = (practice_code) => {
    let url = `learnerlabpractices/${practice_code}`
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`

    }
    return getData(url, { headers })
}
export const submitTodayPractice = (obj, learnerDailyPracticeID, daily_practice_id) => {
    let url = `learnerlabpractices/${learnerDailyPracticeID}/dailypractice/${daily_practice_id}`
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }
    return putData(url, obj, { headers })
}

export const getLearnerQRCode = (learner_code) => {
    let url = `learners/track_qr_code/${learner_code}`
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`

    }
    return getData(url, { headers, responseType: 'blob' })
}
export const getAllTopics = () => {
    let url = `learnerTrackScore`
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`

    }
    return getData(url, { headers })
}